import { AdminShell } from "@/components/admin/AdminShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import RegistrationPeriodsManager from "@/components/admin/RegistrationPeriodsManager";
import BusinessSettingsCard from "@/components/admin/BusinessSettingsCard";
import RegistrationNotificationsCard from "@/components/admin/RegistrationNotificationsCard";
import CommunicationsSettingsCard from "@/components/admin/CommunicationsSettingsCard";
import { Link } from "react-router-dom";
import { CalendarDays, ChevronRight } from "lucide-react";

export default function SettingsPage() {
  return (
    <AdminShell section="settings">
      <div className="container mx-auto p-4 md:p-6 space-y-4">
        <div>
          <h1 className="font-heading text-2xl font-bold text-foreground">Settings</h1>
          <p className="text-sm text-muted-foreground">
            Configuration — registration periods, semester calendar, and integrations.
          </p>
        </div>

        <BusinessSettingsCard />

        <CommunicationsSettingsCard />

        <RegistrationNotificationsCard />

        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <CalendarDays className="h-4 w-4" /> Semester Calendar
            </CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between gap-3">
            <p className="text-sm text-muted-foreground">
              One central place for semester start and end dates, year locks, and copying dates to
              next year. Every class card, form, and confirmation email reads from here.
            </p>
            <Button asChild variant="outline" size="sm">
              <Link to="/admin/settings/academic-calendar">
                Manage <ChevronRight className="h-4 w-4 ml-1" />
              </Link>
            </Button>
          </CardContent>
        </Card>

        <RegistrationPeriodsManager />

        <Card>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <CalendarDays className="h-4 w-4" /> Payroll Rules
            </CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between gap-3">
            <p className="text-sm text-muted-foreground">
              Edit standard Hub rates, view instructor overrides, custom pay schedules, and volunteers.
            </p>
            <Button asChild variant="outline" size="sm">
              <Link to="/admin/settings/payroll-rules">
                Manage <ChevronRight className="h-4 w-4 ml-1" />
              </Link>
            </Button>
          </CardContent>
        </Card>


        <Card>
          <CardHeader><CardTitle className="text-base">More configuration</CardTitle></CardHeader>
          <CardContent className="text-sm text-muted-foreground">
            Coming soon: semester names, sidebar items, payment methods, default emails, vendor pricing,
            payroll schedules, reminder intervals, and alert thresholds.
          </CardContent>
        </Card>
      </div>
    </AdminShell>
  );
}
